// React Query hook for one cited page's drill-down (RGS-3 detail endpoint).
// Lazy-fetched when the Sources page (RGS-5) drawer opens — the row's list data
// renders the header instantly while this fills the signals/history sections.

import { useQuery } from "@tanstack/react-query";
import { vbClient } from "@/services/vb/vbClient";
import { useAuth } from "@/context/AuthContext";
import { vbKeys, useVbWorkspaceScope } from "@/hooks/vb/useBuyers";
import type { SourceDetail } from "@/types/vb";

/** GET /reports/<id>/sources/<source_id>/. Same auth/workspace gating as the
 *  list. `sourceId` is null when no drawer is open → the query stays disabled. */
export function useReportSource(
  reportId: number | undefined,
  sourceId: string | null,
) {
  const { token } = useAuth();
  const { wsKey, wsReady } = useVbWorkspaceScope();
  return useQuery<SourceDetail>({
    queryKey: [...vbKeys.reportSource(reportId ?? -1, sourceId ?? ""), { ws: wsKey }],
    queryFn: () => vbClient.getReportSource(reportId as number, sourceId as string, token),
    enabled: !!reportId && !!sourceId && !!token && wsReady,
    staleTime: 5 * 60 * 1000,
  });
}
